import { SimpleRichTextEditor } from "@/shared/ui/SimpleRichTextEditor";

type FormSectionRichTextEditorProps = {
  /** ສ້າງ editor ໃໝ່ເມື່ອປ່ຽນຟິວ / ໂຫຼດຄ່າ (ໃຊ້ field.id ເປັນ resetKey) */
  resetKey: string;
  initialHtml: string;
  onHtmlChange: (html: string) => void;
  disabled?: boolean;
};

export function FormSectionRichTextEditor({
  resetKey,
  initialHtml,
  onHtmlChange,
  disabled,
}: FormSectionRichTextEditorProps) {
  return (
    <SimpleRichTextEditor
      resetKey={resetKey}
      initialHtml={initialHtml}
      onHtmlChange={onHtmlChange}
      disabled={disabled}
      placeholder="ຂຽນຄຳອະທິບາຍບລັອກນີ້…"
    />
  );
}
